import { TokenType } from '../types';

export const getImpersonatingEmail = (): string | null => {
  return localStorage.getItem('impersonated_user_email');
};

export const getImpersonatingToken = (): string | null => {
  return localStorage.getItem('impersonated_user_token');
};

export const setImpersonation = (email: string, token: string) => {
  localStorage.setItem('impersonated_user_email', email);
  localStorage.setItem('impersonated_user_token', token);
};

export const removeImpersonation = () => {
  localStorage.removeItem('impersonated_user_email');
  localStorage.removeItem('impersonated_user_token');
};

export const getLocalRealUserPath = (): string | null => {
  return localStorage.getItem('real_user_path');
};

export const setLocalRealUserPath = (path: string) => {
  localStorage.setItem('real_user_path', path);
};

export const getLocalRealUser = () => {
  const user = localStorage.getItem('realUser');
  return user ? JSON.parse(user) : undefined;
};

export const setLocalRealUser = (user: any | undefined) => {
  if (user) {
    localStorage.setItem('realUser', JSON.stringify(user));
  } else {
    localStorage.removeItem('realUser');
  }
};

export const getLocalAttestraUser = () => {
  const user = localStorage.getItem('attestraUser');
  return user ? JSON.parse(user) : null;
};

export const setLocalAttestraUser = (user: any | null) => {
  if (user) {
    localStorage.setItem('attestraUser', JSON.stringify(user));
  } else {
    localStorage.removeItem('attestraUser');
  }
};

export const setToken = (tokenObj: any) => {
  localStorage.setItem(TokenType.ACCESS_TOKEN, tokenObj.token);
};

export const setMe = (me: any) => {
  localStorage.setItem('me', JSON.stringify(me));
};

export const getMe = () => {
  const value = localStorage.getItem('me');
  return value ? JSON.parse(value) : undefined;
};

export const removeMe = () => {
  localStorage.removeItem('me');
};

export const getAccessToken = () => {
  return localStorage.getItem(TokenType.ACCESS_TOKEN);
};

export const getAccessTokenSSO = () => {
  return localStorage.getItem(TokenType.ACCESS_TOKEN);
};

export const getRefreshToken = () => {
  return localStorage.getItem(TokenType.REFRESH_TOKEN);
};

export const isToken = (): boolean => {
  return !!localStorage.getItem(TokenType.ACCESS_TOKEN);
};

export const isTokenSSO = (): boolean => {
  return !!localStorage.getItem(TokenType.ACCESS_TOKEN_SSO);
};

export const clearToken = () => {
  localStorage.removeItem(TokenType.ACCESS_TOKEN);
  localStorage.removeItem(TokenType.REFRESH_TOKEN);
  localStorage.removeItem(TokenType.ACCESS_TOKEN_SSO);
  localStorage.removeItem('antibiotique-token-scheme');
  localStorage.removeItem('me');
  localStorage.removeItem('permit');
};

export const setLanguage = (language: string) => {
  localStorage.setItem('language', JSON.stringify(language));
};

export const getLanguage = (): string => {
  const value = localStorage.getItem('language');
  return value ? JSON.parse(value) : 'fr-CA';
};

export const setPermit = (permit: any) => {
  localStorage.setItem('permit', JSON.stringify(permit));
};

export const getPermit = () => {
  const value = localStorage.getItem('permit');
  return value ? JSON.parse(value) : undefined;
};

export const setRequestAccessConfirmed = (requestAccessConfirmed: boolean) => {
  localStorage.setItem('requestAccessConfirmed', JSON.stringify(requestAccessConfirmed));
};

export const getRequestAccessConfirmed = (): boolean => {
  const value = localStorage.getItem('requestAccessConfirmed');
  return value ? JSON.parse(value) : false;
};
